export default __webpack_public_path__ + "static/media/rocket_anim_70.5e902ce4.png";